import { render, staticRenderFns } from "./ShopForm.vue?vue&type=template&id=96c9fb80&"
import script from "./ShopForm.vue?vue&type=script&lang=js&"
export * from "./ShopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports